import { render, staticRenderFns } from "./DataClear.vue?vue&type=template&id=1df4d911&"
import script from "./DataClear.vue?vue&type=script&lang=js&"
export * from "./DataClear.vue?vue&type=script&lang=js&"
import style0 from "./DataClear.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports